import { Banner, Typography } from "@reconvert/react-ui-component";
import { Box, Button, Flex } from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import { Slot, SlotStatus } from "../../models";
import { updateSlotStatusAsync } from "../../app/slice/slotSlice";
import { useTranslation } from "react-i18next";
const bannerType = "warning";

const SlotPublishWarning = ({ slot }: { slot: Slot }) => {
  const { t } = useTranslation();
  const { storeInfo } = useAppSelector(selectAppState);
  const dispatch = useAppDispatch();
  const handleEditorRedirect = () => {
    const editorUrl = `https://manage.wix.com/editor/${storeInfo?.siteId}`;

    window.open(editorUrl, "_blank");
  };

  const handlePublishUpdates = async () => {
    const payload = {
      slotNo: slot.slotNo,
      location: "PRE_PURCHASE_PRODUCT_PAGE",
      updateStatus: SlotStatus.ACTIVE,
    };

    await dispatch(updateSlotStatusAsync({ id: slot.id, body: payload }));
  };

  return (
    <Box mx={"16px"} mt={3} p={2}>
      <Banner
        title={t("It seems like you didn't publish the updates on your store")}
        status={bannerType as any}
        hasBackground
        description=""
        body={
          <Typography variant="body" color="warning.900" textOverflow="ellipsis" overflow="hidden">
            {t(
              `Without visiting the product page on the editor and publishing your store's product page the upsell widget will not be shown. Please go to Wix Editor (product page) and publish the changes to your store`,
            )}
          </Typography>
        }
        footer={
          <Flex gap="8px">
            <Button variant="solid" onClick={handleEditorRedirect} size="sm">
              <Typography variant="small" fontWeight={500}>
                {t("Go to Wix Editor and publish the updates")}
              </Typography>
            </Button>
            <Button variant="Secondary" onClick={handlePublishUpdates} size="sm">
              <Typography variant="small" fontWeight={500}>
                {t("I already published the updates")}
              </Typography>
            </Button>
          </Flex>
        }
      />
    </Box>
  );
};

export default SlotPublishWarning;
